import { useRef } from "react";
import { StepTree as ListStepTree } from "~/components/build/Show/pages/steps/list/components/StepTree";
import { DisplayMode, useFilterStore } from "~/components/build/Show/lib/useFilterStore";
import { useTreeNodes as useListTreeNodes } from "~/components/build/Show/pages/steps/list/components/useTreeNodes";
import { StepTree as SidebarStepTree } from "~/components/build/Show/components/Sidebar/StepTree";
import { useTreeNodes as useSidebarTreeNodes } from "~/components/build/Show/components/Sidebar/useTreeNodes";
import { Table } from "~/components/build/Show/pages/steps/table";

const ListMobileStepsView = () => {
  const displayMode = DisplayMode.Pipeline;
  const filters = useFilterStore((state) => state.filterBy);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { isLoading, nodes } = useListTreeNodes({ displayMode, filters });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (Features.HideBuildSidebar) {
    return (
      <div className="relative h-full w-full flex-auto">
        <Table className="absolute" />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full overflow-auto" ref={scrollRef}>
      <ListStepTree nodes={nodes} displayMode={displayMode} scrollRef={scrollRef} />
    </div>
  );
};

/** @deprecated Use `ListMobileStepsView` instead. */
const SidebarMobileStepsView = () => {
  const displayMode = DisplayMode.Pipeline;
  const filters = useFilterStore((state) => state.filterBy);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { isLoading, nodes } = useSidebarTreeNodes({ displayMode, filters });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (Features.HideBuildSidebar) {
    return (
      <div className="relative h-full w-full flex-auto">
        <Table className="absolute" />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full overflow-auto" ref={scrollRef}>
      <SidebarStepTree nodes={nodes} displayMode={displayMode} scrollRef={scrollRef} />
    </div>
  );
};

export const MobileStepsView = () => {
  if (Features.BuildPageListView) {
    return <ListMobileStepsView />;
  }

  return <SidebarMobileStepsView />;
};
